import styled from "styled-components";
import { theme } from "../../../constants/StyledComponents";

const StyledCheckbox = styled.label`
  display: flex;
  align-items: center;
  position: relative;
  gap: 10px;
  cursor: pointer;

  .checkbox {
    position: relative;
    display: flex;
    align-items: center;

    .checkmark,
    .indeterminate-mark {
      visibility: hidden;
      & > div > svg path {
        stroke-width: 2px;
      }
    }

    & .checkbox-default {
      margin: 0;
      padding: 0;
      width: 20px;
      height: 20px;
      border: 2px solid ${theme.colors.purple};
      border-radius: 3px;
      background-color: white;
      appearance: none;
      cursor: pointer;
      transition:
        background-color 0.2s,
        border-color 0.2s;
    }

    & .checkbox-checked,
    & .checkbox-indeterminate {
      background-color: ${theme.colors.purple};
      border-color: ${theme.colors.purple};
    }

    & .checkbox-checked + .checkmark {
      visibility: visible;
    }

    & .checkbox-indeterminate + .indeterminate-mark {
      visibility: visible;
    }

    & :disabled {
      background-color: white;
      border-color: ${theme.colors.grey_4};
      cursor: default;
    }

    & .checkbox-checked:disabled,
    & .checkbox-indeterminate:disabled {
      background-color: ${theme.colors.grey_4};
      border-color: ${theme.colors.grey_4};
    }

    & > div {
      position: absolute;
      pointer-events: none;
      left: 2px;
      top: 2px;
    }
  }
`;

export { StyledCheckbox };
